import { useCallback, useState } from 'react';
import { SubjectCard, openSubjectFromReport } from '../../services/subjectCardApi';
import { SubjectScope } from './SubjectDossier';

/**
 * Open the baseball / quad card for a field photo taken on this mission.
 * Named faces reuse the existing card; an unnamed snap still mints a stub
 * so the analyst can annotate it mid-run.
 */
export function usePhotoSubject(scope: SubjectScope | null) {
  const [card, setCard] = useState<SubjectCard | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const open = useCallback(async (reportId: string) => {
    if (!scope) return;
    setBusy(true);
    setError(null);
    try {
      setCard(await openSubjectFromReport(scope, reportId));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not open the subject card');
    } finally {
      setBusy(false);
    }
  }, [scope]);

  const close = useCallback(() => setCard(null), []);

  return { card, busy, error, open, close, onSaved: setCard, setError };
}
